module.exports = __webpack_public_path__ + "img/restaurante.b2ac5419.svg";